<div class="popup-container">
  <h2 mat-dialog-title>{{ data.title || 'Filter Options' }}</h2>

  <mat-dialog-content class="popup-content">
    <form [formGroup]="filterForm" class="filter-form">
      @if (!hideTypes) {
        <mat-card class="form-section">
          <mat-card-header>
            <mat-card-title>Types</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div formArrayName="types" class="types-checkbox-group">
              @for (type of data.simTypes; track type; let i = $index) {
                <mat-checkbox
                  [formControlName]="i"
                  class="checkbox-item"
                  >
                  {{ type }}
                </mat-checkbox>
              }
            </div>
          </mat-card-content>
        </mat-card>
      }

      <mat-card class="form-section">
        <mat-card-header>
          <mat-card-title>Run Status</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div formArrayName="runStatuses" class="types-checkbox-group">
            @for (status of data.statuses; track status; let i = $index) {
              <mat-checkbox
                [formControlName]="i"
                class="checkbox-item"
                >
                {{ status }}
              </mat-checkbox>
            }
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="form-section">
        <mat-card-header>
          <mat-card-title>Date Range</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="date-range-container">
            <mat-form-field appearance="outline" class="date-field">
              <mat-label>Start Date</mat-label>
              <input matInput [matDatepicker]="startPicker" formControlName="startDate" />
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="date-field">
              <mat-label>End Date</mat-label>
              <input matInput [matDatepicker]="endPicker" formControlName="endDate" />
              <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
          </div>
          @if (dateRangeError) {
            <div class="error-message">End date must be after start date</div>
          }
        </mat-card-content>
      </mat-card>

      <mat-card class="form-section">
        <mat-card-header>
          <mat-card-title>Directions</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="checkbox-group directions-group">
            <mat-checkbox formControlName="directionX" class="checkbox-item">
              X Direction
            </mat-checkbox>
            <mat-checkbox formControlName="directionY" class="checkbox-item">
              Y Direction
            </mat-checkbox>
            <mat-checkbox formControlName="directionZ" class="checkbox-item">
              Z Direction
            </mat-checkbox>
          </div>
          @if (filterForm.get('directions')?.errors?.['required'] && filterForm.get('directions')?.touched) {
            <div
              class="error-message"
              >
              At least one direction must be selected
            </div>
          }
        </mat-card-content>
      </mat-card>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button (click)="onCancel()" class="cancel-btn">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      (click)="onConfirm()"
      [disabled]="!filterForm.valid"
      class="confirm-btn"
      >
      Apply Filters
    </button>
  </mat-dialog-actions>
</div>
